export function randomFloat(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

export const isValidFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export function formatAmountCents(amountCents?: number | null, fallback = '') {
  if (!isValidFiniteNumber(amountCents)) {
    return fallback;
  }

  return `$${(amountCents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
